export default __webpack_public_path__ + "static/media/art2.ffced396.png";